export interface CookieConsentData {
  hasConsented: boolean;
  analytics: boolean;
  necessary: boolean;
  timestamp: number;
}

export const getCookieConsent = (): CookieConsentData | null => {
  try {
    const saved = localStorage.getItem('cookie-consent');
    if (!saved) return null;
    
    const parsed = JSON.parse(saved);
    return {
      hasConsented: parsed.hasConsented || false,
      analytics: parsed.analytics || false,
      necessary: parsed.necessary || true,
      timestamp: parsed.timestamp || Date.now(),
    };
  } catch (error) {
    console.error('Error reading cookie consent:', error);
    return null;
  }
};

export const setCookieConsent = (data: Omit<CookieConsentData, 'timestamp'>) => {
  try {
    const consentData: CookieConsentData = {
      ...data,
      timestamp: Date.now(),
    };
    localStorage.setItem('cookie-consent', JSON.stringify(consentData));
    return true;
  } catch (error) {
    console.error('Error saving cookie consent:', error);
    return false;
  }
};

export const hasUserMadeChoice = (): boolean => {
  const consent = getCookieConsent();
  return consent !== null && consent.hasConsented;
};

export const clearCookieConsent = (): boolean => {
  try {
    localStorage.removeItem('cookie-consent');
    return true;
  } catch (error) {
    console.error('Error clearing cookie consent:', error);
    return false;
  }
}; 